import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { connect } from 'react-redux';
import { Trans } from 'react-i18next';
import { animateToScreen } from '../../redux/ui/actions';
import { setCurrentZone, setTicketZones } from '../../redux/cardReader/actions';
import {
  TICKET_TYPE_ADDITIONAL_ZONE,
  MOBILE_BREAKPOINT_IN_PX,
  TABLET_BREAKPOINT_IN_PX,
} from '../../constants';
import { canAdditionalZoneBePurchased } from '../../zones';
import { getZoneButtonsComponent, getZoneBackgroundImage } from '../helpers';
import CardReaderScreen from '../../molecules/CardReaderScreen';
import Bubble from '../../components/Bubble';
import { ErrorText } from '../../components/Typography';

const fadeInTransform = keyframes`
  from {
    opacity: 0;
    transform: translateY(100%);
  }

  to {
    opacity: 1;
    transform: translateY(60%);
  }
`;

const BubbleWrapper = styled.div`
  position: absolute;
  z-index: 4;
  transform: translateY(60%);
  animation-name: ${fadeInTransform};
  animation-duration: 250ms;
  left: -16px;
  top: ${(props) => props.top - 30}px;

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    left: -26px;
    top: ${(props) => props.top - 55}px;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    left: -10px;
    top: ${(props) => props.top - 160}px;
  }
`;

class AdditionalZoneRegionRC extends PureComponent {
  // eslint-disable-next-line
  state = {
    showError: false,
    valueTicketZones: null,
    errorPosition: 0,
  };

  onZoneClick = (event, zones) => {
    const { layerY, offsetY } = event && event.nativeEvent;
    const errorPosition = layerY + 60 - offsetY;
    const { seasonalTicketZones } = this.props;
    if (canAdditionalZoneBePurchased(zones, seasonalTicketZones)) {
      this.props.setTicketZones(zones);
      this.props.goToPurchaseScreen();
      this.setState({ showError: false });
    } else {
      this.setState({
        showError: true,
        valueTicketZones: zones,
        errorPosition,
      });
    }
  };

  onCloseBubble = () => this.setState({ showError: false });

  render() {
    const { currentZone, previousScreen, seasonalTicketZones } = this.props;
    const { valueTicketZones, errorPosition } = this.state;
    const ZoneButtonsComp = getZoneButtonsComponent(currentZone);
    const zoneImg = getZoneBackgroundImage(currentZone);
    const fadeDuration = previousScreen === 'Home' ? '0ms' : '500ms';
    const aOrAn = seasonalTicketZones && seasonalTicketZones[0] === 'A' ? 'an' : 'a'; // eslint-disable-line
    return (
      <CardReaderScreen backgroundImage={zoneImg} fadeDuration={fadeDuration}>
        <ZoneButtonsComp
          onClickZoneAB={(e) => this.onZoneClick(e, 'AB')}
          onClickZoneABC={(e) => this.onZoneClick(e, 'ABC')}
          onClickZoneABCD={(e) => this.onZoneClick(e, 'ABCD')}
          onClickZoneBCD={(e) => this.onZoneClick(e, 'BCD')}
          onClickZoneCD={(e) => this.onZoneClick(e, 'CD')}
          onClickZoneBC={(e) => this.onZoneClick(e, 'BC')}
          onClickZoneD={(e) => this.onZoneClick(e, 'D')}
          onClickUpButton={() => this.props.setCurrentZone(`${currentZone[0]}`)}
          onClickDownButton={() => this.props.setCurrentZone(`${currentZone}2`)}
        />
        {this.state.showError && (
          <BubbleWrapper top={errorPosition}>
            <Bubble onClose={this.onCloseBubble}>
              <ErrorText>
                <Trans
                  i18nKey="AdditionalZoneRegion.error"
                  values={{ seasonalTicketZones, valueTicketZones, aOrAn }}
                />
              </ErrorText>
            </Bubble>
          </BubbleWrapper>
        )}
      </CardReaderScreen>
    );
  }
}
AdditionalZoneRegionRC.propTypes = {
  goToPurchaseScreen: PropTypes.func.isRequired,
  setCurrentZone: PropTypes.func.isRequired,
  setTicketZones: PropTypes.func.isRequired,
  previousScreen: PropTypes.string.isRequired,
  currentZone: PropTypes.string.isRequired,
  seasonalTicketZones: PropTypes.string.isRequired,
};

const mapStateToProps = ({ ui, cardReader }) => ({
  previousScreen: ui.previousScreen,
  currentZone: cardReader.currentZone,
  seasonalTicketZones: cardReader.additionalZoneTicket.seasonalTicketZones,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentZone: (zone) => dispatch(setCurrentZone(zone)),
  goToPurchaseScreen: () => dispatch(animateToScreen('AdditionalZonePurchase')),
  setTicketZones: (zones) => dispatch(setTicketZones(TICKET_TYPE_ADDITIONAL_ZONE, zones)),  // eslint-disable-line
});

// prettier-ignore
export default connect(mapStateToProps, mapDispatchToProps)(AdditionalZoneRegionRC);
